export const Skeleton = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`animate-pulse rounded-md bg-neutral-200 ${className}`} />
);
